








































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import SumupTab from "../../components/SumupTab.vue";
import AlertArea from "../../components/AlertArea.vue";
import { Sheet, SumupSheet } from '../../modules/teacher/SumupScoreAverageList';

const ModalImageKindEnum = Object.freeze({Scan: 1, Result: 2});

export interface Data {
  tabNo: number
  sheet_group_key: string
  sheet: Sheet | null
  sumupSheets: SumupSheet[]
  SheetTypeEnum: Readonly<{Normal: number; Cbt: number; Entrance: number}>
  errors: string[]
}

export default defineComponent({
  components: {
    "sumup-tab": SumupTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 1,
      sheet_group_key: "",
      sheet: null,
      sumupSheets: new Array<SumupSheet>(),
      SheetTypeEnum: Common.SheetTypeEnum,
      errors: [],
    });


    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_group_key = context.root.$route.params.sheet_group_key;
      await http.get(`/api/teacher/sumup_score_average_list?sheet_group_key=${state.sheet_group_key}`).then(response => {
        
        state.sheet = new Sheet(response.data.sheet);
        response.data.sheet_hashes.forEach((x: any) => {
          state.sumupSheets.push(new SumupSheet(x));
        });
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goSheetList");
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
    };
  }
});

